import { render, staticRenderFns } from "./BasePageContainer.vue?vue&type=template&id=39a49f4b&scoped=true&"
import script from "./BasePageContainer.vue?vue&type=script&lang=js&"
export * from "./BasePageContainer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39a49f4b",
  null
  
)

export default component.exports